export type LoadState = "unavailable" | "expired" | "loading" | "failed";

export function connectorLoadState(
  enabled: boolean,
  query: { isPending: boolean; isError: boolean; data: unknown },
  expired = false
): LoadState | null {
  if (!enabled) return "unavailable";
  if (expired) return "expired";
  if (query.isPending) return "loading";
  if (query.isError || !query.data) return "failed";
  return null;
}
